export const replaceLocation = (route: string) => window.location.replace(route);
